import { render } from "./a-mobile.vue?vue&type=template&id=053f1baa&scoped=true"
import script from "./a-mobile.vue?vue&type=script&lang=js"
export * from "./a-mobile.vue?vue&type=script&lang=js"

import "./a-mobile.vue?vue&type=style&index=0&id=053f1baa&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053f1baa"]])

export default __exports__